<template>
  <div class="olderDetailService">
    <el-row style="margin-top:10px;">
      <!-- 表格内容栏 -->
      <div class="content">
        <el-row>
          <el-form
            v-for="(table, index) in tableData"
            :key="index"
            :model="table.hospitalFeeForm"
            label-width="0px"
            :ref="table.hospitalFeeForm"
            label-position="right"
            class="hospitalFeeForm"
          >
            <el-row class="title">
              <el-col :span="24">
                <span class="spam-img"
                  ><img
                    src="@/assets/beadhouse/juxing.png"
                    alt=""
                    style="vertical-align:middle;margin:0 10px;"
                /></span>
                <span class="span-text">{{ table.name }}</span>
                <span
                  v-if="table.needSelectOne == 0"
                  style="margin-left:5px;color:green"
                  >(非必选项目)</span
                >
                <span v-else style="margin-left:5px;color:red">(必选项)</span>
              </el-col>
            </el-row>

            <!-- 针对床位费的  code=1 -->
            <table v-if="table.code == 1">
              <tbody>
                <tr class="tr">
                  <td class="tdStyle">床位名称</td>
                  <td colspan="2" class="tdStyleTwo">
                    <el-form-item label prop="bedNo" label-width="0px">
                      <el-input
                        v-model="table.hospitalFeeForm.bedNo"
                        style="width:50%;"
                        :disabled="selectDisabled"
                        auto-complete="off"
                        @focus="focusBed"
                      ></el-input>
                    </el-form-item>
                  </td>
                  <td class="tdStyle">房间类型</td>
                  <td colspan="2" class="tdStyleThree">
                    <el-form-item label>
                      <el-row>{{ table.hospitalFeeForm.roomType }}</el-row>
                    </el-form-item>
                  </td>
                </tr>
                <tr class="tr">
                  <td class="tdStyle">床位描述</td>
                  <td colspan="2" class="tdStyleTwo">
                    <el-form-item label>
                      <el-row>{{ table.hospitalFeeForm.content }}</el-row>
                    </el-form-item>
                  </td>
                  <td class="tdStyle">床位费用</td>
                  <td colspan="2" class="tdStyleThree">
                    <el-form-item label>
                      <el-row>{{
                        table.hospitalFeeForm.chargeStandard
                      }}</el-row>
                    </el-form-item>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- 针对护理费的  code=2 -->
            <!-- <table v-else-if="table.code == 2">
              <tbody>
                <tr class="tr">
                  <td class="tdStyle">项目名称</td>
                  <td colspan="2" class="tdStyleTwo">
                    <el-form-item label-width="0px">
                      <el-select
                        v-model="table.hospitalFeeForm.projectName"
                        :clearable="table.needSelectOne == 0"
                        :disabled="selectDisabled"
                        placeholder="请选择项目"
                        style="width:50%"
                        @change="val => {changeSelect(val, index);}"
                      >
                        <el-option
                          v-for="item in table.expenseItemList"
                          :key="item.id"
                          :label="item.itemName"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td class="tdStyle">收费方式</td>
                  <td colspan="2" class="tdStyleThree">
                    <el-form-item label="" label-width="0px">
                      <el-row>{{ table.hospitalFeeForm.feeStyle }}</el-row>
                    </el-form-item>
                  </td>
                </tr>
                <tr class="tr">
                  <td class="tdStyle">描述</td>
                  <td colspan="2" class="tdStyleTwo">
                    <el-form-item label="" label-width="0px">
                      <el-row>{{ table.hospitalFeeForm.content }}</el-row>
                    </el-form-item>
                  </td>
                  <td class="tdStyle">费用</td>
                  <td colspan="2" class="tdStyleThree">
                    <el-form-item label="" label-width="0px">
                      <el-row v-if="table.hospitalFeeForm.isFixedPrice == 1">{{
                        table.hospitalFeeForm.fee
                      }}</el-row>
                      <el-row v-if="table.hospitalFeeForm.isFixedPrice == '0'">
                        <el-input
                          v-model.trim="table.hospitalFeeForm.fee"
                          :disabled="selectDisabled"
                          placeholder="请输入费用"
                          style="width:90%"
                          @blur="
                            changeSingleFee(
                              table.hospitalFeeForm.fee,
                              table.hospitalFeeForm.projectName
                            );
                          "
                        ></el-input>
                      </el-row>
                    </el-form-item>
                  </td>
                </tr>
              </tbody>
            </table> -->
            <!-- 单选 table.canMultipleChoose==0 -->
            <table v-else-if="table.canMultipleChoose == 0">
              <tbody>
                <tr class="tr">
                  <td class="tdStyle">项目名称</td>
                  <td colspan="2" class="tdStyleTwo">
                    <el-form-item label-width="0px">
                      <el-select
                        v-model="table.hospitalFeeForm.projectName"
                        :clearable="table.needSelectOne == 0"
                        :disabled="selectDisabled"
                        placeholder="请选择项目"
                        style="width:50%"
                        @change="val => {changeSelect(val, index);}"
                      >
                        <el-option
                          v-for="item in table.expenseItemList"
                          :key="item.id"
                          :label="item.itemName"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td class="tdStyle">收费方式</td>
                  <td colspan="2" class="tdStyleThree">
                    <el-form-item label="" label-width="0px">
                      <el-row>{{ table.hospitalFeeForm.feeStyle }}</el-row>
                    </el-form-item>
                  </td>
                </tr>
                <tr class="tr">
                  <td class="tdStyle">描述</td>
                  <td colspan="2" class="tdStyleTwo">
                    <el-form-item label="" label-width="0px">
                      <el-row>{{ table.hospitalFeeForm.content }}</el-row>
                    </el-form-item>
                  </td>
                  <td class="tdStyle">费用</td>
                  <td colspan="2" class="tdStyleThree">
                    <el-form-item label="" label-width="0px">
                      <!-- <el-row>{{table.hospitalFeeForm.fee}}</el-row> -->
                      <!-- isFixedPrice ==0 不固定  isFiexedPrice ==1 固定 -->
                      <el-row v-if="table.hospitalFeeForm.isFixedPrice == 1">{{
                        table.hospitalFeeForm.fee
                      }}</el-row>
                      <el-row v-else-if="table.hospitalFeeForm.isFixedPrice == '0'">
                        <el-input
                          v-model.trim="table.hospitalFeeForm.fee"
                          :disabled="selectDisabled"
                          placeholder="请输入费用"
                          style="width:90%"
                          @blur="
                            changeSingleFee(
                              table.hospitalFeeForm.fee,
                              table.hospitalFeeForm.projectName
                            );
                          "
                        ></el-input>
                      </el-row>
                    </el-form-item>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- 多选  table.canMultipleChoose==1 -->
            <el-table
              v-else-if="table.canMultipleChoose == 1"
              border
              :data="table.expenseItemList"
              :header-cell-style="tableHeaderColor"
              :ref="'multipleTable' + table.id"
              style="width:100%;margin-top:10px;"
              @selection-change="val => {handleSelectionChange(val, index);}"
            >
              <el-table-column
                type="selection"
                width="55"
                :selectable="handleDisable"
              ></el-table-column>
              <el-table-column
                prop="itemName"
                label="项目名称"
                min-width="150"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="costType"
                label="收费方式"
                :formatter="formatCostType"
                min-width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="content"
                label="描述"
                min-width="200"
                align="center"
              ></el-table-column>
              <!--
                <el-table-column prop="chargeStandard" label="费用" min-width="200" align=center></el-table-column>
              -->
              <el-table-column label="费用" min-width="200" align="center">
                <!--
                  isFixedPrice==0 不固定--可输入  isFixedPrice==1 固定--不可输入
                -->
                <template slot-scope="scope">
                  <span v-if="scope.row.isFixedPrice == 1">{{
                    scope.row.chargeStandard
                  }}</span>
                  <el-input
                    v-else
                    v-model.trim="scope.row.chargeStandard"
                    :disabled="selectDisabled"
                    placeholder="请输入费用"
                    style="width:90%"
                    @blur="changeMultipleFee(scope.$index, scope.row);"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-row>
      </div>
    </el-row>
    <div slot="footer" class="footer" align="center">
      <el-button type="warning" plain @click="last">返回</el-button>
      <el-button type="primary" plain @click="next">下一步</el-button>
    </div>

    <!-- 房间床位选择弹窗 -->
    <el-dialog
      title="床位入住"
      style="margin-top:-10vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="roomBeddialogVisible"
      width="80%"
    >
      <el-row>
        <span style="margin-left:20px">入住:{{ officialBed + tryBed }}人</span>
        <span style="margin-left:20px">空床:{{ emptyBed }}张</span>
        <span style="margin-left:20px">已预约:{{ orderBed }}张</span>
        <span style="margin-left:30px">楼栋:</span>
        <el-select
          v-model="buildId"
          placeholder="请选择"
          style="width:120px"
          @change="selectRoomdialogShow"
        >
          <el-option
            v-for="item in buildList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <img
          src="@/assets/beadhouse/nan.png"
          style="display:inline-block;vertical-align:middle;margin-left:30px;"
        />
        <span>男</span>
        <img
          src="@/assets/beadhouse/nv.png"
          style="display:inline-block;vertical-align:middle;margin-left:20px;"
        />
        <span>女</span>
        <img
          src="@/assets/beadhouse/kongchuang_icon.png"
          style="display:inline-block;vertical-align:middle;margin-left:20px;"
        />
        <span>空床</span>
        <img
          src="@/assets/beadhouse/yiyuyue.png"
          style="display:inline-block;vertical-align:middle;margin-left:20px;"
        />
        <span>已预约</span>
      </el-row>
      <el-row>
        <room-bed-show
          v-bind:yuyue="2"
          v-bind:floorlist="floorList"
          v-bind:type="2"
          @getChildRoomBedData="clickRoomBedData"
        ></room-bed-show>
      </el-row>
    </el-dialog>

  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import RoomBedShow from "@/components/RoomBedShow"; //引入第三方组件
export default {
  name: "OlderDetailFeeChoose",
  components: {
    RoomBedShow
  },
  data() {
    return {
      selectDisabled: "", //单选表格的下拉框是否可以选取修改
      isPayed: "", //是否已缴费的状态  0---未缴  1---已缴   武昌福利院的  生成缴费单后再次进来就不能再修改费用
      oldmanId: "", //老人的id
      tableData: [], //table表格的数据源
      tableLoading: false, //table加载的loading
      multipleSelection: [], //多选的 表格选中的数据
      echoDataList: [], //已选择项目表格回显的数据
      paidItemList: [], //老人需要支付的项目表格回显的数据
      roomBeddialogVisible: false, //床位选择弹窗的显示与否
      buildId: "",
      currentFloorList: [],
      olderDetailService:{
        queryExpenseItem:"omc/selectExpense/queryExpenseItem/",//可购买项目查询
        bindExpenseItem:"omc/selectExpense/bindExpenseItem",//已选择项目保存
        showAllBuild:"omc/Building/showAll",//查询该机构所有楼栋
        showAllBed:"omc/Room/showAll",//查询该机构所有床位
        queryBedFee:"omc/selectExpense/matchBedFeeByBedId/",//匹配床位费
        queryCareLevelByOldManId:"cac/CacOldman/queryByOldManId",//已经填写基本信息的老人通过老人id去查询护理等级
        matchCareFeeByCareType:"omc/selectExpense/matchCareFeeByCareType/",//护理费匹配
        queryOldmanExpenseItem:"omc/selectExpense/queryOldmanExpenseItem/",//已选择项目查询
        queryOldManInfo:"omc/selectExpense/getOldmanInfoByOldmanId/",//获取老人的基本信息
        queryAllCycle:"omc/prepaidCycle/queryAll",//预缴周期查询数据
        getCycleDaysByGroupId:"omc/returnFeeConfig/getByGroupId/",//查询配置数据回显
        matchSetMeal:"omc/selectExpense/matchSetMeal/",//查询匹配的套餐
        paymentInformation:"omc/selectExpense/generateOldmanInBill",//入院缴费单生成（武昌福利院）
        queryBedNo:"omc/Bed/selectByBedId",//查询床位
        queryRoom:"omc/Room/selects",//查询房间 
        getAdvisoryBedId:"omc/selectExpense/getAdvisoryBedId/",//获取咨询记录中的床位id
        queryPaidItemByOldmanId:"omc/selectExpense/queryPaidItemByOldmanId/",//查询是否生成了缴费信息
        deleteSelectItemByModelCode:"omc/selectExpense/deleteSelectItemByModelCode",//根据缴费模式码删除已选择项目
        queryCheckInDays:"omc/selectExpense/queryCheckInDays",//缴费周期剩余天数计算
        paymentInformationleyi:"omc/selectExpense/oldmanInOfLeyi",//入院生成缴费单（乐颐社区版）
    },
      buildList: [],
      floorList: [],
      bedId: "", //获取床位的id
      bedNo: "", //获取床位的编号
      bedDataInfo: {}, //床位的信息
      careLevelInfo: {}, //护理等级的信息
      status: -1, //判断是回显什么数据   初始化状态为-1    0--回显 已选择项目的    1--回显老人需支付的项目展示
      officialBed: 0, //正式入住
      emptyBed: 0, //空床
      orderBed: 0, //已预约
      tryBed: 0 //试入住
    };
  },
  methods: {
    /* 上一步 */
    last() {
      bus.$emit("admissiondetail", "last");
    },
    /* 下一步 */
    next() {
      console.log(this.tableData);
      var params = new Array();
      this.tableData.forEach(item => {
        if(item.canMultipleChoose == 1){
          //多选
          if (item.hospitalFeeForm!=null && item.hospitalFeeForm.checkList!=null){
            item.hospitalFeeForm.checkList.forEach(item2 =>{
              let paramsObj = new Object();
              paramsObj.oldmanId = this.oldmanId; //老人的id
              paramsObj.amount = 1;
              paramsObj.modelCode = 1; //1是入院收费   2是周期收费   3是出院收费   4是非周期收费
              paramsObj.expenseTypeId = item2.expenseTypeId; //消费类别id
              paramsObj.expenseItemId = item2.id; //消费项目的id
              paramsObj.chargeStandard = item2.chargeStandard * 1;
              params.push(paramsObj);
            })
          }
        }else{
          //单选
          if (item.hospitalFeeForm!=null){
              let paramsObj = new Object();
              paramsObj.oldmanId = this.oldmanId; //老人的id
              paramsObj.amount = 1;
              paramsObj.modelCode = 1; //1是入院收费   2是周期收费   3是出院收费   4是非周期收费
              paramsObj.expenseTypeId = item.hospitalFeeForm.expenseTypeId; //消费类别id
              paramsObj.expenseItemId = item.hospitalFeeForm.id; //消费项目的id
              paramsObj.chargeStandard = item.hospitalFeeForm.fee * 1;
              if(item.code == 1){
                paramsObj.remark = item.hospitalFeeForm.bedNo;
              }
              params.push(paramsObj);
          }
        }
      });
      if (this.isPayed == 0) {
        this.$postJson(
          "omc/selectExpense/bindOldExpenseItem",
          params
        ).then(res => {
          console.log(res);
          if (res.code == 200) {
            this.setSelectBedId();
            this.$message({ message: res.message, type: "success" });
            
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      } else {
        setTimeout(() => {
              bus.$emit("admissiondetail", "next");
        }, 50);
      }
    },

    /* 
      将老人的id和床位绑定 暂绑进去
      老人入住到该床位
    */
    setSelectBedId() {
      let params = new Object();
      params.oldmanId = this.oldmanId;
      params.bedId = this.bedId;
      if(this.bedId == null || this.bedId == undefined || this.bedId.length<1){
        bus.$emit("admissiondetail", "next");
        return;
      }
      this.$postForm("omc/selectExpense/setSelectBedId", params).then(res => {
        bus.$emit("admissiondetail", "next");
        console.log(res);
      });
    },
    formatCostType(row){
      let costTypeY = "";
      switch(row.costType){
        case 1:
          costTypeY = "元/次";
          break;
        case 2:
          costTypeY = "元/天";
          break;
        case 3:
          costTypeY = "元/月";
          break;
        case 4:
          costTypeY = "元/年";
          break;
        case 5:
          costTypeY = "元/一次性";
          break;
        default:
          costTypeY = "元/一次性";
          break;
      }
      return costTypeY;
    },
    /* 
      项目名称的下拉框change事件  针对单选的
    */
    changeSelect(value,index) {
      this.tableData[index].expenseItemList.forEach(item=>{
        if (item.id == value){
           let costTypeX = "";
           switch (item.costType) {
              case 1:
                costTypeX = "元/次";
                break;
              case 2:
                costTypeX = "元/天";
                break;
              case 3:
                costTypeX = "元/月";
                break;
              case 4:
                costTypeX = "元/年";
                break;
              case 5:
                costTypeX = "元/一次性";
                break;
              default:
                costTypeX = "元/一次性";
                break;
            }
          this.$set(item, "feeStyle", costTypeX);
          this.$set(item, "fee", item.chargeStandard * 1);
          this.$set(item, "projectName", item.itemName);
          this.tableData[index].hospitalFeeForm = item;
        }
      });
    },
    /* 
      表格的选择  
    */
    handleSelectionChange(val, index) {
      this.tableData[index].hospitalFeeForm.checkList = [];
      this.tableData[index].expenseItemList.forEach(item =>{
          val.forEach(mult => {
          if (item.id == mult.id) {
            this.tableData[index].hospitalFeeForm.checkList.push(mult);
          }
        });
      });
    },
    /* 
      单选表格的项目费用的输入框change
    */
    changeSingleFee(fee, id) {
      console.log(fee, id, this.tableData);
      var reg = /(^[0-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/g; //大于等于0的数，最多可以有两位小数正则表达式
      //不为空
      if (fee != "") {
        if (reg.test(fee)) {
          if (fee > 9999999.99) {
            this.$message({
              message: "请输入不大于9999999.99并且最多只能有两位小数的金额",
              type: "error"
            });
            this.tableData.forEach(item => {
              console.log(item.expenseItemList);
              item.expenseItemList.forEach(temp => {
                if (id == temp.id) {
                  // item.hospitalFeeForm.fee = "";//清空
                  item.hospitalFeeForm.fee = 0; //赋值0
                }
              });
            });
          }
        } else {
          this.$message({
            message: "请输入不小于0并且最多只能有两位小数的金额",
            type: "error"
          });
          this.tableData.forEach(item => {
            console.log(item.expenseItemList);
            item.expenseItemList.forEach(temp => {
              if (id == temp.id) {
                //item.hospitalFeeForm.fee = "";//清空
                item.hospitalFeeForm.fee = 0; //赋值0
              }
            });
          });
        }
      } else {
        //为空
        this.tableData.forEach(item => {
          console.log(item.expenseItemList);
          item.expenseItemList.forEach(temp => {
            if (id == temp.id) {
              //item.hospitalFeeForm.fee = "";//清空
              item.hospitalFeeForm.fee = 0; //赋值0
            }
          });
        });
      }
    },

    /* 
      多选表格的项目的输入框change
    */
    changeMultipleFee(index, row) {
      console.log(index, row);
      var reg = /(^[0-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/g; //大于等于0的数，最多可以有两位小数正则表达式
      if (row.chargeStandard != "") {
        if (reg.test(row.chargeStandard)) {
          if (row.chargeStandard > 9999999.99) {
            this.$message({
              message: "请输入不大于9999999.99并且最多只能有两位小数的金额",
              type: "error"
            });
            // row.chargeStandard='';//清空
            row.chargeStandard = 0; //赋值0
          }
        } else {
          this.$message({
            message: "请输入不小于0并且最多只能有两位小数的金额",
            type: "error"
          });
          // row.chargeStandard='';//清空
          row.chargeStandard = 0; //赋值0
        }
      } else {
        row.chargeStandard = 0; //赋值0
      }
    },
    //单选表格的
    queryselect() {
      if (this.isPayed == 1) {
        //isPayed---1  已缴 不可修改 
        this.selectDisabled = true;
      } else {
        //isPayed----0  未缴 可修改
        this.selectDisabled = false;
      }
    },

    /* 
    多选table列表前面的checkBox是否可以选择
    */
    handleDisable(row, index) {
      if (this.isPayed == 1) {
        //isPayed---1  已缴 不可修改 
        return false;
      } else {
        //isPayed----0  未缴 可修改
        return true;
      }
    },

    /* 
      床位费打开dialog模态框
    */
    focusBed() {
      console.log("跳转到床位选择");
      this.roomBeddialogVisible = true;
      this.queryBuild();
    },
    selectRoomdialogShow(val) {
      console.log(val);
      this.buildId = val;
      this.queryBed(this.buildId);
    },
    queryBuild() {
      this.buildList = []; //清空数据 防止累加
      this.$postForm(this.olderDetailService.showAllBuild).then(res => {
        console.log(res);
        if (res.code == 200) {
          if (res.result != null || res.result.length > 0) {
            res.result.forEach((item, index) => {
              console.log(item, "------");
              this.buildList.push({
                label: item.buildingName,
                value: String(item.buildingId)
              });
              if (index == 0) {
                this.buildId = String(item.buildingId);
              }
            });
          }
          console.log(
            this.buildList,
            "this.buildlist",
            this.buildId,
            "this.buildId"
          );
          this.queryBed(this.buildId);
        }
      });
    },
    /* 
      获取床位  通过buildinid 
    */
    queryBed(buildingId) {
      let params = new Object();
      params.buildingId = buildingId;
      (this.officialBed = 0), //正式入住
        (this.emptyBed = 0), //空床
        (this.orderBed = 0), //已预约
        (this.tryBed = 0), //试入住
        this.$postForm(this.olderDetailService.showAllBed, params).then(
          res => {
            console.log(res);
            if(res.result == null){
              this.currentFloorList = [];
            }else{
              this.currentFloorList = res.result.floorList;
            }
            this.controlFloorData();
          }
        );
    },
    /* 
      处理床位的数据
    */
    controlFloorData() {
      //为了一个房间太多床位的显示异常
      let floorList = [];
      for (let i = 0; i < this.currentFloorList.length; i++) {
        let roomList = [];
        //获取房间列表
        for (let j = 0; j < this.currentFloorList[i].roomList.length; j++) {
          let pageList = [];
          this.currentFloorList[i].roomList[j] = this.getBedSrc(
            this.currentFloorList[i].roomList[j]
          );
          //let allBedList = this.currentFloorList[i].roomList[j].bedViewList;
          let allBedList = this.currentFloorList[i].roomList[j].bedList; //by guo 2019-08-26-15:42 修改 根据实际获取的字段名 bedList 去处理数据
          //切割数组,然后进行分页添加上去
          for (var k = 0; k < allBedList.length; k += 4) {
            var bedList = allBedList.slice(k, k + 4);
            pageList.push({
              bedList: bedList
            });
          }
          let roomData = {
            //roomno: this.currentFloorList[i].roomList[j].roomno,
            roomno: this.currentFloorList[i].roomList[j].roomNo, //by guo 2019-08-26-15:42 修改 根据实际获取的字段名 roomNo 去处理数据
            roomId: this.currentFloorList[i].roomList[j].id,
            roomType: this.currentFloorList[i].roomList[j].roomType,
            pageList: pageList
          };
          roomList.push(roomData);
        }

        let floorData = {
          floorNo: this.currentFloorList[i].floorNo,
          roomList: roomList
        };
        floorList.push(floorData);
      }
      this.floorList = floorList;
      //this.roomBeddialogVisible = true;
    },
    /*
     *根据房间和床位,设置它的src,如果需要修改显示的逻辑,请修改这里
     *床位状态 0-空床 1-暂出 2-有人  3-咨询入住时的预约 4-入住时的预约 5 - 试入住 6-调房预约 7-待缴费
     */
    getBedSrc(roomData) {
      var bedList = roomData.bedList;
      bedList.forEach(bedItem => {
        //by guo 2019-08-26-15:42 修改 根据实际获取的字段名 bedList 去处理数据
        if (bedItem.status == 2 || bedItem.status == 4 || bedItem.status == 5) {
          //入住
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/nv.png");
          }
          this.officialBed++; //正式入住
        }if (bedItem.status == 3){
          bedItem.src = require("@/assets/beadhouse/yiyuyue.png");
        }
        // || bedItem.status == 3
         else if (bedItem.status == 0) {
          //空床
          bedItem.src = require("@/assets/beadhouse/kongchuang_icon.png");
          this.emptyBed++; //空床
        } else if (bedItem.status == 7) {
          //待缴费
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/daijiaofei_nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/daijiaofei_nv.png");
          }
        } else if (bedItem.status == 6) {
          //by guo 2019-11-28-13:42添加
          //调整中
          bedItem.src = require("@/assets/beadhouse/tiaozhengzhong_nan.png");
        }
      });
      return roomData;
    },
    /* 
      点击房间床位，将床位bedId和床位号带过来
    */
    clickRoomBedData(data) {
      if (
        data.bedtype.status == 0
      ) {
        this.$confirm("确定要选择此空床吗？", "选择床位", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        })
          .then(() => {
            this.bedId = data.bedid; //获取床位的bedId
            this.bedNo = data.bedno; //获取床位的编号bedNo
            this.queryBedFee(this.bedId);
            this.roomBeddialogVisible = false;
          })
          .catch(() => {});
      } else if (data.bedtype.status == 3 || data.bedtype.status == 4) {
        this.$confirm("确定是预约人？", "选择床位", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        })
          .then(() => {
            this.bedId = data.bedid; //获取床位的bedId
            this.bedNo = data.bedno; //获取床位的编号bedNo
            this.queryBedFee(this.bedId);
            this.roomBeddialogVisible = false;
          })
          .catch(() => {});
      } else if (data.bedtype.status == 6) {
        this.$message({ message: "此床位调房调级调整中", type: "error" });
      } else if (
        data.bedtype.status == 2 ||
        data.bedtype.status == 5 ||
        data.bedtype.status == 7
      ) {
        //判断人是不是自己
        if(data.bedtype.oldmanId != this.oldmanId){
          this.$message({ message: "此床位有人", type: "error" });
        }else{
            this.bedId = data.bedid; //获取床位的bedId
            this.bedNo = data.bedno; //获取床位的编号bedNo
            this.queryBedFee(this.bedId);
            this.roomBeddialogVisible = false;
        }
      } else if (data.bedtype.bedType == null) {
        this.$message({
          message: "该床位护理类型未设置,需要设置后才能选择",
          type: "error"
        });
      }
    },

    /* 
      床位费匹配
    */
    queryBedFee(bedId) {
      this.$postJson(this.olderDetailService.queryBedFee + bedId).then(
        res => {
          if (res.code == 200) {
            this.bedDataInfo.itemName = res.result.itemName; //消费项目名称
            this.bedDataInfo.expenseTypeId = res.result.expenseTypeId; //消费类别的id
            this.bedDataInfo.id = res.result.id; //消费项目id
            var costTypeY = "";
            switch (
              res.result.costType //收费频次方式（1-元/次 2-元/天 3-元/月 4-元/年 5-元/一次性）
            ) {
              case 1:
                costTypeY = "元/次";
                break;
              case 2:
                costTypeY = "元/天";
                break;
              case 3:
                costTypeY = "元/月";
                break;
              case 4:
                costTypeY = "元/年";
                break;
              case 5:
                costTypeY = "元/一次性";
                break;
              default:
                costTypeY = "元/一次性";
                break;
            }
            this.bedDataInfo.costType = costTypeY; //收费方式
            this.bedDataInfo.content = res.result.content; //床位描述
            this.bedDataInfo.chargeStandard = res.result.chargeStandard; //收费标准
            this.bedDataInfo.fee = res.result.chargeStandard; //收费标准
            this.bedDataInfo.expenseItemId =res.result.expenseItemId; //收费标准 
            this.bedDataInfo.expenseTypeId =res.result.expenseTypeId; //收费标准 
            var roomTypeY = "";
            switch (
              res.result.roomType //收费频次方式（1-单人间 2-双人间 3-三人间 4-四人及四人间以上）
            ) {
              case 1:
                roomTypeY = "单人间";
                break;
              case 2:
                roomTypeY = "双人间";
                break;
              case 3:
                roomTypeY = "三人间";
                break;
              default:
                roomTypeY = "四人及四人间以上";
            }
            this.bedDataInfo.roomType = roomTypeY;
            this.$nextTick(() => {
              setTimeout(() => {
                this.tableData.forEach(item => {
                  if(item.code == 1){
                    this.$set(item.hospitalFeeForm, "bedNo", this.bedNo); //设置床位的编号回显
                    this.$set(
                      item.hospitalFeeForm,
                      "roomType",
                      this.bedDataInfo.roomType
                    ); 
                    this.$set(
                      item.hospitalFeeForm,
                      "id",
                      this.bedDataInfo.id
                    ); 
                    this.$set(
                      item.hospitalFeeForm,
                      "expenseTypeId",
                      this.bedDataInfo.expenseTypeId
                    ); 
                    this.$set(
                      item.hospitalFeeForm,
                      "content",
                      this.bedDataInfo.content
                    ); 
                    this.$set(
                      item.hospitalFeeForm,
                      "chargeStandard",
                      this.bedDataInfo.chargeStandard
                    ); 
                    this.$set(
                      item.hospitalFeeForm,
                      "fee",
                      this.bedDataInfo.chargeStandard
                    ); 
                  }
                });
              }, 10);
            });
          } else if (res.code == 10037017) {
            this.$message({ message: res.message, type: "error" });
            this.bedNo = ""; //清除床位编号
            this.bedDataInfo.itemName = ""; //清除消费项目名称
            this.bedDataInfo.expenseTypeId = ""; //清除消费类别的id
            this.bedDataInfo.expenseItemId = ""; //清除消费项目id
            this.bedDataInfo.costType = ""; //清除收费方式
            this.bedDataInfo.content = ""; //清除床位描述
            this.bedDataInfo.chargeStandard = ""; //清除收费标准
            this.bedDataInfo.roomType = ""; //清除房间类型
          }
        }
      );
    },
    
    /* 
      通过老人的id查询护理等级  0---自理  1---半自理   3---失能
    */
    queryCareLevelByOldManId() {
      let params = new Object();
      params.oldmanId = this.oldmanId; //by guo 2020-7-30-15:19 修改二次出院的问题
      this.$postForm(
        "omc/Oldman/selectOldManSupByOld",
        params
      ).then(res => {
        let careType = res.result.levelCareName; //获取护理等级
        this.matchCareFeeByCareType(careType)
      });
      
    },
    quertBedByOld(){
      //查询老人入住的床位信息
      this.$postJson(
        this.olderDetailService.queryOldManInfo + this.oldmanId
      ).then(res => {
          //查询老人信息 获取床位号,回显上去
          if (res.result.bedId != null) {
            this.bedId = res.result.bedId;
            // 回显床位费
            this.queryBedFee(this.bedId);
            //查询床位 回显 bedNo
            this.queryBedNo(this.bedId);
          }
      });
    },

    /* 
      根据床位id去查询房间id
    */
    queryBedNo(bedId) {
      let params = new Object();
      params.bedId = bedId;
      this.$postForm(this.olderDetailService.queryBedNo, params).then(
        res => {
          console.log(res);
          let roomId = res.result.roomId;
          //查询床位
          this.queryRoom(roomId);
        }
      );
    },
    
    /* 
      根据房间id去查房间和床位信息
    */
    queryRoom(roomId) {
      let params = new Object();
      params.roomId = roomId;
      this.$postForm(this.olderDetailService.queryRoom, params).then(
        res => {
          var roomNo = res.result.roomNo;
          res.result.bedList.forEach(item => {
            if (this.bedId == item.bedId) {
              let bedNo = roomNo + "-" + item.bedNo;
              this.matchBedFeeByBed(bedNo,res.result);
            }
          });
        }
      );
    },
    matchBedFeeByBed(bedNo,room){
      this.bedNo = bedNo;
      console.log(room);
      this.tableData.forEach(item => {
          if(item.code == 1){
            this.$set(item.hospitalFeeForm, "bedNo", this.bedNo); //设置床位的编号回显

          }
      });
    },

    /* 
      通过护理等级再去查询老人的护理信息
    */
    matchCareFeeByCareType(careType) {
      //自理等级 string
      this.tableData.forEach(item=>{
        if(item.code == 2){
          //护理费
          item.expenseItemList.forEach(item2=>{
            if(item2.levelCareName == careType){
              console.log(item2);
              console.log("matchCareFeeByCareTypematchCareFeeByCareType");
              item.hospitalFeeForm = {
                projectName:item2.itemName,
                expenseTypeId: item2.expenseTypeId,
                expenseItemId: item2.id,
                id:item2.id,
                feeStyle:this.getCostTypeStrFromId(item2.costType),
                content:item2.content,
                isFixedPrice:1,
                fee:item2.chargeStandard
              };
            }
          })
        }
      })
    },

    getCostTypeStrFromId(costType){
          var costTypeY = "";
          switch (
            costType //收费频次方式（1-元/次 2-元/天 3-元/月 4-元/年 5-元/一次性）
          ) {
            case 1:
              costTypeY = "元/次";
              break;
            case 2:
              costTypeY = "元/天";
              break;
            case 3:
              costTypeY = "元/月";
              break;
            case 4:
              costTypeY = "元/年";
              break;
            case 5:
              costTypeY = "元/一次性";
              break;
            default:
              costTypeY = "元/一次性";
              break;
          }
          return costTypeY;
    },

    /* 
      表头的颜色
    */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#fff;color:#6f7075;font-weight: 700;height:50px;";
      }
    },
    queryOldmanChooseFee(){
      //omc/selectExpense/queryOldmanExpenseItem
      //查询老人选择的费用项目
      this.$postJson(
        "omc/selectExpense/queryOldExpenseItem/" + this.oldmanId
      ).then(res =>{
        if(res.result == null || res.result.length == 0){
          //全部都未选
          //查询护理级别. 床位
          this.queryCareLevelByOldManId();
          this.quertBedByOld();
        }else{
          //回显并获取老人入院状态; 是否已缴费,已缴费则无法修改
          if (res.result !=null && res.result.length!=0 && res.result[0].status != 0) {
            // 已确认入院账单， 置为false
            this.selectDisabled = true;
            this.isPayed = 1;
          }
          this.quertBedByOld();
          this.tableData.forEach(item2=>{
              if(item2.canMultipleChoose == 1){
                item2.hospitalFeeForm.checkList = [];
                item2.expenseItemList.forEach(item3 =>{
                  res.result.forEach(item =>{
                    //再和table for循环一次
                    if(item3.id == item.expenseItemId){
                      item3.fee = item3.chargeStandard;
                      item2.hospitalFeeForm.checkList.push(item3);
                      setTimeout(()=>{
                         this.$refs[`multipleTable${item2.id}`][0].toggleRowSelection(item3)
                      },10)
                    }
                  })
                })
              }else{
                //单选的
                item2.expenseItemList.forEach(item3 =>{
                  res.result.forEach(item =>{
                    //再和table for循环一次
                    if(item3.id == item.expenseItemId){
                      var costTypeY = "";
                      switch (
                        item3.costType //收费频次方式（1-元/次 2-元/天 3-元/月 4-元/年 5-元/一次性）
                      ) {
                        case 1:
                          costTypeY = "元/次";
                          break;
                        case 2:
                          costTypeY = "元/天";
                          break;
                        case 3:
                          costTypeY = "元/月";
                          break;
                        case 4:
                          costTypeY = "元/年";
                          break;
                        case 5:
                          costTypeY = "元/一次性";
                          break;
                        default:
                          costTypeY = "元/一次性";
                          break;
                      }
                      if(item2.code == 1){
                        var roomTypeY = "";
                        switch (
                          res.result.roomType //收费频次方式（1-单人间 2-双人间 3-三人间 4-四人及四人间以上）
                        ) {
                          case 1:
                            roomTypeY = "单人间";
                            break;
                          case 2:
                            roomTypeY = "双人间";
                            break;
                          case 3:
                            roomTypeY = "三人间";
                            break;
                          default:
                            roomTypeY = "四人及四人间以上";
                        }
                        item3.roomType = roomTypeY;
                      }
                      item3.feeStyle = costTypeY; //收费方式
                      item3.fee = item.chargeStandard;
                      item3.projectName = item3.id;
                      item2.hospitalFeeForm = item3;
                    }
                  })
                })
              }
            })
          console.log(this.tableData)
        }
      })
    },
    //查询全部费用
    queryAllFee(){
      this.feeItemOptions = []; //清空数据，防止累加
      this.typeOptions = []; //清空数据，防止累加
      this.$postJson("omc/expenseType/queryAll").then(
        (res) => {
          console.log(res, "查询类别以及消费项");
          if (res.code == 200) {
            if (res.result.length > 0) {
              let tableData = [];
              res.result.forEach((item, index) => {
                console.log(item, index);
                item.hospitalFeeForm = {};
                // 3的 是入院一次性费用
                if(item.code == 3){
                  //排到前面去
                  tableData.splice(0, 0, item);
                }else if(item.code <3){
                  tableData.push(item);
                }
              });
              this.tableData = tableData;
              this.queryOldmanChooseFee();
            }
          }
        });
    }
  },
  activated(){
    this.oldmanId = sessionStorage.getItem("editOldmanId"); //获取老人的id
    if (this.oldmanId != null) {
      this.queryAllFee();
    }
    this.isPayed = 0;
    this.queryselect();
  },
  mounted() {
    //延时加载 等dom对象生成以后再去加载  否则有些数据无法获取
    this.oldmanId = sessionStorage.getItem("editOldmanId"); //获取老人的id
    if (this.oldmanId != null) {
      // 1. 查询全部的费用类别项目
      this.queryAllFee();
    }
    this.isPayed = 0;
    this.queryselect();
  }
};
</script>
<style lang="scss" scoped>
.olderDetailService {
  .title {
    height: 54px;
    line-height: 54px;
    background: #f9f7fa;
    border: 1px #f1eff2 solid;
    .span-img {
      height: 54px;
      line-height: 54px;
      margin-left: 10px;
    }
    .span-text {
      height: 54px;
      line-height: 54px;
      font-size: 16px;
    }
  }
  .hospitalFeeForm {
    margin-bottom: 30px;
  }
  table {
    width: 100%;
    margin: 10px auto;
    border-collapse: collapse;
    border: 1px solid #cccccc;
  }
  .tr {
    height: 100px;
    text-align: center;
  }
  .tdStyle {
    color: #6f7075;
    font-weight: 700;
    height: 50px;
  }
  .tdStyleTwo {
    color: #6f7075;
    font-weight: 700;
    width: 400px;
    height: 50px;
  }
  .tdStyleThree {
    color: #6f7075;
    font-weight: 700;
    width: 250px;
    height: 50px;
  }
  td {
    border: 1px solid #cccccc;
  }

  .footer {
    padding: 30px 0;
    background: #fff;
  }
  ::v-deep .hospitalFeeForm .el-form-item {
    margin-bottom: 0px;
  }
}
</style>
